export default __webpack_public_path__ + "static/media/Flag_of_Barbados.c5b5e01a.svg";